import { render } from "./FpuiInputTags.vue?vue&type=template&id=32fd7d27&lang=pug"
import script from "./FpuiInputTags.vue?vue&type=script&lang=js"
export * from "./FpuiInputTags.vue?vue&type=script&lang=js"

import "./FpuiInputTags.vue?vue&type=style&index=0&id=32fd7d27&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__